import { render } from "./Dialog.vue?vue&type=template&id=542d4bf0"
import script from "./Dialog.vue?vue&type=script&lang=js"
export * from "./Dialog.vue?vue&type=script&lang=js"

import "./Dialog.vue?vue&type=style&index=0&id=542d4bf0&lang=less"
script.render = render

export default script